module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/train-81b50fcd1c7fe5ff8fdb01c4baef552d.svg";